<template>
    <form class="form-subs mw-500 mx-auto"
          @submit.prevent="submitForm">
        <div class="form-group-fields">
            <div class="form-field w-100 mb-0">
                <input
                    v-model="email"
                    type="email"
                    id="form-subs-email"
                    placeholder=""
                    autocomplete="email"
                    required
                >
                <label for="form-subs-email">Email here<sup>*</sup></label>
            </div>
            <button
                class="btn btn--dark"
                :disabled="isLoading"
                type="submit"
            >Subscribe</button>
        </div>
    </form>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
    name: "Subscribe",
    data() {
        return {
            isLoading: false, // защита от множественных запросов
            isSend: false, // форма успешно отправлена
            email: '',
        }
    },
    computed: {
        domain() {
            return window.location.hostname.replace('www', '')
        }
    },
    methods: {

        emptyField( field ) {
            const v = field.trim();
            return v !== '' ? 'filled' : 'empty';
        },

        isValidEmail() {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return regex.test( this.email ) || ! this.email;
        },


        /**
         * Отправка формы
         */
        async submitForm() {

            if( this.isLoading )
                return;

            if( ! this.isValidEmail() ) {
                this.$alert.error('The email field is filled in incorrectly.')
                return;
            }

            this.isLoading = true

            try {
                const response = await this.$http.post('/ref/subscription', {email:this.email})

                // Достаём данные из ответа
                const { status, code, data } = response.data;
                const message = data?.message;

                // Показываем уведомление, если есть сообщение
                if (message) {
                    // Динамический вызов по статусу с fallback на 'info'
                    const alertMethod = this.$alert[ status ];
                    if( typeof alertMethod === 'function' ) {
                        alertMethod( message );
                    } else {
                        this.$alert.info( message );
                    }
                }

                // Дополнительная логика по статусу success
                if( status === 'success' ) {
                    this.isSend = true;
                    this.email = '';
                } else if (status === 'error' && code === 404) {
                    console.warn('Source not found');
                }

            } catch (err) {
                console.error('error: ', err)
            } finally {
                this.isLoading = false
            }
        },
    }
})
</script>

<style scoped>

</style>